import axios from 'axios';
import { Notification, MessageBox, Message, Loading } from 'element-ui'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 设置 axios 的基础 URL
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10 * 60 * 1000
});

// 添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么，比如添加 token
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    return response.data;
  },
  (error) => {
    // 对响应错误做点什么
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      console.error('Error:', error.response.data);
      console.error('Status:', error.response.status);
    } else {
      // 比如网络错误
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

// 封装通用的请求方法
export const fetchData = (url, params = {}) => {
  return instance.get(url, { params });
};

// 封装 POST 请求
export const postData = (url, data = {},headers = {'Content-Type': 'application/json;charset=utf-8'}) => {
  return instance.post(url, data, { headers: headers });
};
